import { render, staticRenderFns } from "./editorPCPreviewNew.vue?vue&type=template&id=079d38f1&scoped=true"
import script from "./editorPCPreviewNew.vue?vue&type=script&lang=js"
export * from "./editorPCPreviewNew.vue?vue&type=script&lang=js"
import style0 from "./editorPCPreviewNew.vue?vue&type=style&index=0&id=079d38f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079d38f1",
  null
  
)

export default component.exports